import styled from "styled-components";

const StyledSeatOptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export { StyledSeatOptionWrapper };
